"use strict";

var _toConsumableArray = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _3_vote_transaction_1 = require("./3_vote_transaction");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var validateInputs = function validateInputs(_ref) {
  var _ref$votes = _ref.votes,
      votes = _ref$votes === void 0 ? [] : _ref$votes,
      _ref$unvotes = _ref.unvotes,
      unvotes = _ref$unvotes === void 0 ? [] : _ref$unvotes;

  if (!Array.isArray(votes)) {
    throw new Error('Please provide a valid votes value. Expected an array if present.');
  }

  if (!Array.isArray(unvotes)) {
    throw new Error('Please provide a valid unvotes value. Expected an array if present.');
  }

  utils_1.validatePublicKeys([].concat(_toConsumableArray(votes), _toConsumableArray(unvotes)));
};

exports.castVotes = function (inputs) {
  validateInputs(inputs);
  var passphrase = inputs.passphrase,
      secondPassphrase = inputs.secondPassphrase,
      _inputs$votes = inputs.votes,
      votes = _inputs$votes === void 0 ? [] : _inputs$votes,
      _inputs$unvotes = inputs.unvotes,
      unvotes = _inputs$unvotes === void 0 ? [] : _inputs$unvotes;
  var plusPrependedVotes = utils_1.prependPlusToPublicKeys(votes);
  var minusPrependedUnvotes = utils_1.prependMinusToPublicKeys(unvotes);
  var allVotes = [].concat(_toConsumableArray(plusPrependedVotes), _toConsumableArray(minusPrependedUnvotes));
  var transaction = Object.assign({}, utils_1.createBaseTransaction(inputs), {
    type: 3,
    fee: constants_1.VOTE_FEE.toString(),
    asset: {
      votes: allVotes
    }
  });

  if (!passphrase) {
    return transaction;
  }

  var transactionWithSenderInfo = Object.assign({}, transaction, {
    senderId: transaction.senderId,
    senderPublicKey: transaction.senderPublicKey,
    recipientId: transaction.senderId,
    recipientPublicKey: transaction.senderPublicKey
  });
  var voteTransaction = new _3_vote_transaction_1.VoteTransaction(transactionWithSenderInfo);
  voteTransaction.sign(passphrase, secondPassphrase);
  return voteTransaction.toJSON();
};